import {
  INDICATOR_GROUP_BY_TYPES_MAP,
  IndicatorGroupByTypes,
} from 'business/shift-report/indicators/pages/indicator-analyze/providers/filters/types';

export function getCurrentAnalysisType(
  filteredBy: 'date' | 'ring',
  groupedBy: IndicatorGroupByTypes,
) {
  if (filteredBy === 'ring') {
    return 'ring';
  }
  switch (groupedBy) {
    case INDICATOR_GROUP_BY_TYPES_MAP.report:
      return 'report';
    case INDICATOR_GROUP_BY_TYPES_MAP.day:
      return 'day';
    case INDICATOR_GROUP_BY_TYPES_MAP.week:
      return 'week';
    case INDICATOR_GROUP_BY_TYPES_MAP.month:
      return 'month';
    default: {
      throw new Error(`group type '${groupedBy}' is invalid.`);
    }
  }
}
